import React from "react";
import SingleActivite from "./SingleActivite";

const Activitebody = () => {
  return (
    <>
      <div className="bg-white radius5 px-20 py-20 singleActiviteGrid pink semibold ds14 mt-10">
        <div>Statut</div>
        <div>Planification</div>
        <div>Priorité</div>
        <div>Activité</div>
        <div></div>
      </div>
      <SingleActivite />
      <SingleActivite />
    </>
  );
};

export default Activitebody;
